import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ValueFilterPipe } from './value-filter.pipe';
import { ValueRequiredFilterPipe } from './value-required-filter.pipe';
import { TableSearchPipe } from './table-search.pipe';
import { NegToParnthPipe } from './neg-to-parnth.pipe';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
      ValueFilterPipe
    , ValueRequiredFilterPipe
    , TableSearchPipe
    , NegToParnthPipe],
  exports: [
      ValueFilterPipe
    , ValueRequiredFilterPipe
    , NegToParnthPipe
    , TableSearchPipe

  ]
})
export class PipesModule { }



// WEBPACK FOOTER //
// ./src/app/pipes/pipes.module.ts